export default "__VITE_ASSET__h0zCy5pJ__"